import React from 'react';
import { Autocomplete, TextField, FormControl, FormHelperText, CircularProgress } from '@mui/material';
import { Controller } from 'react-hook-form';

const CustomAutocomplete = React.memo(({
  name,
  control,
  label,
  options,
  error,
  helperText,
  isLoading,
  onChange,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange: fieldOnChange, value, ...field } }) => (
        <FormControl fullWidth error={!!error}>
          <Autocomplete
            {...field}
            value={value || null}
            onChange={(_, newValue) => {
              fieldOnChange(newValue);
              if (onChange) {
                onChange(_, newValue);
              }
            }}
            options={options}
            loading={isLoading}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                error={!!error}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            ListboxProps={{
              style: {
                maxHeight: 300,
                width: 'auto',
                minWidth: 250,
              },
            }}
            {...props}
          />
          {error && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    />
  );
});

export default CustomAutocomplete; 